import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

/**
 * If the page was pre-rendered by `scripts/prerender.js` (post-build), the
 * document.head has <meta name="prerendered" content="true">. In that case we
 * hydrate so React re-uses the already-painted DOM; otherwise we render fresh.
 */
const rootEl = document.getElementById("root");
const prerendered = document.querySelector('meta[name="prerendered"][content="true"]');

const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (prerendered && rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, tree, {
    // Hydration mismatches on marketing surfaces (date formatting, theme flashes)
    // should not blank the page. Swallow them so the client takes over cleanly.
    onRecoverableError: () => {},
  });
} else {
  ReactDOM.createRoot(rootEl).render(tree);
}
